import { v4 as uuidV4 } from 'uuid';

import { BreakoutRoom } from '@/types/session.types';

type TGetDefaultBreakoutRoomOptions = {
  type?: 'interest' | 'random' | 'assigned';
};

const getDefaultBreakoutRoom = (options?: TGetDefaultBreakoutRoomOptions): BreakoutRoom => {
  return {
    session: 0,
    uuid: uuidV4(),
    name: '',
    max_users: 15,
    type: options?.type || 'interest',
    image: '',
    imageUploading: false,
    nameFocused: false,
    video_settings: {},
    closed: false,
  };
};

export default getDefaultBreakoutRoom;
